import React from "react";
import TypingAnimation from '../Layout/typingAnimation';

export default function HeroSection() {
  return (
    <div className="w-full h-screen relative isolate px-6 pt-1 lg:px-8 z-10 " >
      {/* Top background shape */}
      <div
        aria-hidden="true"
        className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
      >
        <div
          style={{
            clipPath:
              "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
          }}
          className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
        />
      </div>

      {/* Main content */}
      <div className="mx-auto max-w-2xl py-32 sm:py-38 lg:py-42">
        {/* Announcement banner */}
        <div className="hidden sm:mb-8 sm:flex sm:justify-center ">
          <div className="relative rounded-full px-3 py-1 text-sm leading-6 text-gray-600 ring-1 ring-gray-900/10 hover:ring-gray-900/20">
            I'm evolving into a full-stack developer!{" "}
            <a href="/about" className="font-semibold text-indigo-600">
              <span aria-hidden="true" className="absolute inset-0" />
              Learn about my journey <span aria-hidden="true">&rarr;</span>
            </a>
          </div>
        </div>

        {/* Hero text */}
        <div className="text-center ">
          <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl ">
            Crafting solutions from design to development
          </h1>
          <p className="mt-6 text-lg leading-8 text-gray-600">
            Combining creativity and code to bring ideas to life. Here's what I do:
            <TypingAnimation />
          </p>

          {/* Call to action buttons */}
          <div className="mt-10 flex items-center justify-center gap-x-6 ">
            <a
              href="/contact"
              className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Work with me
            </a>
            <a
              href="/projects"
              className="text-sm font-semibold leading-6 text-gray-900"
            >
              See my projects <span aria-hidden="true">→</span>
            </a>
          </div>
        </div>
      </div>

      {/* Bottom background shape */}
      <div
        aria-hidden="true"
        className="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]"
      >
        <div
          style={{
            clipPath:
              "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
          }}
          className="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]"
        />
      </div>
    </div>
  );
}
